export enum TransactionTypeEnum {
    /**Sconosciuto */
    Unknown = -1,

    /**Deposito */
    Deposit = 0,

    /**Ritiro sacca */
    EmptyBag = 1,

    /**Fine giornata */
    EndDay = 2,

    /**Ritiro del contante gestito manualmente */
    ManualEmpty = 3,

    /**Prelievo */
    Withdrawal = 4,

    /**Svuotamento magazzini */
    EmptyStocks = 5,

    /**Spostamento in sacca */
    MoveToBag = 6,

    /**Cambio */
    Change = 7,

    /**Carico */
    Refill = 8,

    /**Bilancio utente */
    UserBalance = 9,

    /**Ripristino del dispositivo */
    Resume = 10,

    /**Carico a mano */
    ManualRefill = 11,

    /**Modifica contenuto in seguito a variazioni contenuto dopo blocchi */
    ChangedContent = 12,

    /**Svuotamento rulli in sacca */
    EmptyToBag = 13,

    /**Deposito manuale */
    ManualDeposit = 14,

    /**Pagamento */
    Payment = 15,

    /**
     * Trasferimento di contante verso un certo magazzino
     * (pe move to cassette)
     */
    Transfer = 16,

    /**Ritiro della cassetta */
    CassetteCollection = 17,

    /** Deposit to a virtual safe */
    VirtualSafeDeposit = 18,

    /** Virtual safe withdrawal */
    VirtualSafeWithdrawal = 19,

    /** Cash in hopper collection */
    CashInHopperCollection = 20,
}

export function transactionTypeEnumLabel(val: TransactionTypeEnum): string {
    let res = "";
    switch (val) {
        case TransactionTypeEnum.Unknown:
            res = "common.unknown";
            break;
        case TransactionTypeEnum.Deposit:
            res = "enum.transaction_types.deposit";
            break;
        case TransactionTypeEnum.EmptyBag:
            res = "enum.transaction_types.empty_bag";
            break;
        case TransactionTypeEnum.EndDay:
            res = "enum.transaction_types.end_day";
            break;
        case TransactionTypeEnum.ManualEmpty:
            res = "enum.transaction_types.manual_empty";
            break;
        case TransactionTypeEnum.Withdrawal:
            res = "enum.transaction_types.withdrawal";
            break;
        case TransactionTypeEnum.EmptyStocks:
            res = "enum.transaction_types.empty_stocks";
            break;
        case TransactionTypeEnum.MoveToBag:
            res = "enum.transaction_types.move_to_bag";
            break;
        case TransactionTypeEnum.Change:
            res = "enum.transaction_types.change";
            break;
        case TransactionTypeEnum.Refill:
            res = "enum.transaction_types.refill";
            break;
        case TransactionTypeEnum.UserBalance:
            res = "enum.transaction_types.user_balance";
            break;
        case TransactionTypeEnum.Resume:
            res = "enum.transaction_types.resume";
            break;
        case TransactionTypeEnum.ManualRefill:
            res = "enum.transaction_types.manual_refill";
            break;
        case TransactionTypeEnum.ChangedContent:
            res = "enum.transaction_types.changed_content";
            break;
        case TransactionTypeEnum.EmptyToBag:
            res = "enum.transaction_types.empty_to_bag";
            break;
        case TransactionTypeEnum.ManualDeposit:
            res = "enum.transaction_types.manual_deposit";
            break;
        case TransactionTypeEnum.Payment:
            res = "enum.transaction_types.payment";
            break;
        case TransactionTypeEnum.Transfer:
            res = "enum.transaction_types.transfer";
            break;
        case TransactionTypeEnum.CassetteCollection:
            res = "enum.transaction_types.cassette_collection";
            break;
        case TransactionTypeEnum.VirtualSafeDeposit:
            res = "enum.transaction_types.virtual_safe_deposit";
            break;
        case TransactionTypeEnum.VirtualSafeWithdrawal:
            res = "enum.transaction_types.virtual_safe_withdrawal";
            break;
        case TransactionTypeEnum.CashInHopperCollection:
            res = "enum.transaction_types.cashinhopper_collection";
            break;
        default:
            res = "common.unknown";
            break;
    }
    return res;
}
